<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<p class="EP"><span epub:type="pagebreak" id="pg_ix" title="ix"><span class="ePub-I">Magic is only as black as the heart that practices it.</span></span></p>
<p class="EPC"><span class="epc-I">Abramo Fiorentino</span></p>
<p class="EP"><span class="ePub-I">Real magic is the transformation of self.</span></p>
<p class="EPC-NOBOT"><span class="epc-I">J.M. Dillard</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?971b4606